import IBAN from 'iban';

export const ibanValidator = (iban: string): boolean => {
  return IBAN.isValid('PL' + iban);
};

/**
 * Checks if the bank codes are correct.
 * @param bankCode - The bank code to validate.
 * @returns True if the bank code is in the common list, false otherwise.
 */
export const getBankNameByIban = (iban: string): string => {
  const bankCode = iban.slice(2, 6);
  return bankCodes[bankCode as keyof typeof bankCodes];
};

const bankCodes = {
  '1010': 'Narodowy Bank Polski',
  '1020': 'PKO BP',
  '1030': 'Bank Handlowy (Citi Handlowy)',
  '1050': 'ING Bank Śląski',
  '1060': 'Bank BPH',
  '1090': 'Santander Bank Polska',
  '1130': 'Bank Gospodarstwa Krajowego (BGK)',
  '1140': 'mBank',
  '1160': 'Bank Millennium',
  '1240': 'Pekao SA',
  '1280': 'HSBC',
  '1320': 'Bank Pocztowy',
  '1540': 'BOŚ Bank',
  '1580': 'Mercedes-Benz Bank Polska',
  '1610': 'SGB - Bank',
  '1680': 'Plus Bank',
  '1840': 'Societe Generale',
  '1870': 'Nest Bank',
  '1930': 'Bank Polskiej Spółdzielczości',
  '1940': 'Credit Agricole Bank Polska',
  '2030': 'BNP Paribas Bank Polska',
  '2120': 'Santander Consumer Bank',
  '2160': 'Toyota Bank',
  '2190': 'DNB Bank Polska',
  '2480': 'VeloBank',
  '2490': 'Alior Bank',
  '2770': 'Volkswagen Bank',
  '2790': 'Raiffeisen Digital Bank',
  '2910': 'Aion Bank',
};
